import lottie from 'lottie-web';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class BodyMoving {

    constructor() {
        this.bodymovingwrap = document.querySelectorAll('.bodymoving');
        this.init();
    }

    init() {
        
        // this.bodymovingwrap.length;
        this.bodymovingwrap.forEach((el) => {
            if(el.dataset.once=='once'){
                ScrollTrigger.create({
                    trigger: document.querySelector('.js-bodymoving-once'),
                    start: "top 80%",
                    toggleActions:"play null null null",
                    once: true,
                    onEnter: ()=>{
                        lottie.loadAnimation({
                            container: document.querySelector('.js-bodymoving-once'),
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            path: document.querySelector('.js-bodymoving-once').dataset.path,
                        });
                    },
                });
            }
            else{
                lottie.loadAnimation({
                    container: el.querySelector('.js-bodymoving'),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: el.querySelector('.js-bodymoving').dataset.path,
                });
            }
        });
    }
}

export default BodyMoving;
